module.exports = __webpack_public_path__ + "6a8fb293f9bd5619fb16076f7674f749.png";